//NEW STYPEPARAMS METHOD
var CONTENT_PLACEMENT_ANIMATIONS = {
    NO_EFFECT: 'NO_EFFECT',
    SLIDE: 'SLIDE',
};
export default CONTENT_PLACEMENT_ANIMATIONS;
//# sourceMappingURL=behaviourParams_item_content_placementAnimation.js.map